import { useNavigate } from "react-router-dom";
import { customAuthAxios } from "../../utils/customAuthAxios";
import { useSuccessToast } from "../toast/useSuccessToast";
import { useErrorToast } from "../toast/useErrorToast";


export const useEditStaffSurveySelectedQuestions = (restaurantId?: string) => {
  const navigate = useNavigate();
  const showToast = useSuccessToast();
  const showErrorToast = useErrorToast();

  const onSubmit = async (data: any) => {
    try {
      const res = await customAuthAxios.post(
        `restaurant_staff/restaurants/${restaurantId}/survey/questions/selected/`,
        data
      );
      showToast(res.data.message);
      navigate(-1);
    } catch (error: any) {
      if (error.response && error.response.status === 400) {
        showErrorToast(error.response.data.detail)
      }
    }
  };
  return onSubmit;
};